import autobind from 'autobind-decorator';
import * as React from 'react';
import history from 'login-utils/history';

import States from 'login-constants/states';
import * as userUtils from 'login-utils/userUtils';
import TermsOfService from './TermsOfService';
import TermsOfServicePixelTracker from './TermsOfServicePixelTracker';

export interface TermsOfServiceContainerState {
  isSubmitting: boolean;
}

@autobind
class TermsOfServiceContainer extends React.Component<{}, TermsOfServiceContainerState> {
  constructor(props: {}) {
    super(props);
    this.state = { isSubmitting: false };
  }

  UNSAFE_componentWillMount() {
    // We shouldn't be in this state unless we have a current user.
    if (!userUtils.getCurrentUser()) {
      return history.push(States.LOGIN);
    }
  }

  onSubmit() {
    // Do nothing with event since this is a regular HTML form submission.
    /* istanbul ignore next: (UI-5482) */
    this.setState({ isSubmitting: true });
  }

  render() {
    return (
      <div>
        <TermsOfService onSubmit={this.onSubmit} isSubmitting={this.state.isSubmitting} />
        <TermsOfServicePixelTracker />
      </div>
    );
  }
}

export default TermsOfServiceContainer;
